// extracted by mini-css-extract-plugin
export default {"withdrawButton":"PdrSZKn3jU6tJgAo5cHj","disable":"ZefAPYrP29ogwpI1o1dw"};